import { createFeatureSelector } from '@ngrx/store';
import { BRAND_PLP_FEATURE_NAME } from '~app/modules/brand-plp/store/feature-name';

export const getBrandPLPState = createFeatureSelector(
  BRAND_PLP_FEATURE_NAME
);
